import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { useAuth } from '../contexts/AuthContext';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navLinks = [
    { path: '/home', label: 'Home' },
    { path: '/features', label: 'Features' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/company', label: 'Company' }
  ];

  return (
    <nav style={{
      padding: 'clamp(1rem, 3vw, 1.5rem) 5%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid rgba(255,255,255,0.1)',
      gap: 'clamp(0.5rem, 2vw, 1rem)',
      background: '#000000',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      backdropFilter: 'blur(10px)'
    }}>
      {/* Left Section - Menu Button (Mobile) + Logo */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        flexShrink: 0
      }}>
        {/* Mobile Menu Button - Left Side */}
        {isMobile && (
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{
              background: 'transparent',
              border: '1px solid rgba(135, 206, 235, 0.3)',
              color: '#87CEEB',
              padding: '0.5rem',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '36px',
              height: '36px',
              transition: 'all 0.3s ease'
            }}
          >
            <Icon icon={isMenuOpen ? "mdi:close" : "mdi:menu"} width="20" />
          </button>
        )}


      </div>

      {!isMobile && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'clamp(1.5rem, 3vw, 2rem)',
          flexWrap: 'wrap'
        }}>
          {navLinks.map(link => (
            <a
              key={link.path}
              onClick={() => navigate(link.path)}
              style={{
                color: location.pathname === link.path ? '#87CEEB' : 'rgba(255, 255, 255, 0.7)',
                textDecoration: 'none',
                fontSize: 'var(--font-xs)',
                fontWeight: location.pathname === link.path ? '600' : '400',
                cursor: 'pointer',
                transition: 'color 0.2s ease',
                borderBottom: location.pathname === link.path ? '2px solid #87CEEB' : 'none',
                paddingBottom: '0.25rem'
              }}
              onMouseEnter={(e) => {
                if (location.pathname !== link.path) {
                  e.target.style.color = '#ffffff';
                }
              }}
              onMouseLeave={(e) => {
                if (location.pathname !== link.path) {
                  e.target.style.color = 'rgba(255, 255, 255, 0.7)';
                }
              }}
            >
              {link.label}
            </a>
          ))}
        </div>
      )}

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? '0.5rem' : 'clamp(0.5rem, 2vw, 1rem)',
        flexShrink: 0,
        position: 'relative'
      }}>
        {user ? (
          <>
            {!isMobile && (
              <span style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: 'var(--font-xxs)',
                marginRight: '1rem'
              }}>
                歡迎回來，{user.name}
              </span>
            )}
            <button
              onClick={() => navigate('/home')}
              style={{
                background: "white",
                border: 'none',
                color: '#87CEEB',
                padding: isMobile ? '0.4rem 0.8rem' : 'clamp(0.4rem, 1vw, 0.5rem) clamp(1rem, 3vw, 1.5rem)',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: isMobile ? '0.85rem' : 'clamp(0.85rem, 2vw, 0.95rem)',
                fontWeight: '600',
                boxShadow: '0 0 15px rgba(135, 206, 235, 0.4), 0 4px 12px rgba(135, 206, 235, 0.2)',
                whiteSpace: 'nowrap'
              }}
            >
              {isMobile ? '主控台' : '前往主控台'}
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => navigate('/login')}
              style={{
                background: 'transparent',
                border: '1px solid rgba(255,255,255,0.3)',
                color: '#ffffff',
                padding: isMobile ? '0.4rem 0.8rem' : 'clamp(0.4rem, 1vw, 0.5rem) clamp(1rem, 3vw, 1.5rem)',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: isMobile ? '0.85rem' : 'clamp(0.85rem, 2vw, 0.95rem)',
                whiteSpace: 'nowrap'
              }}
            >
              登入
            </button>
            {!isMobile && (
              <button
                onClick={() => navigate('/register')}
                style={{
                  background: "#87CEEB",
                  border: 'none',
                  color: '#ffffff',
                  padding: 'clamp(0.4rem, 1vw, 0.5rem) clamp(1rem, 3vw, 1.5rem)',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: 'var(--font-xxs)',
                  fontWeight: '600',
                  boxShadow: '0 4px 12px rgba(135, 206, 235, 0.3)',
                  whiteSpace: 'nowrap'
                }}
              >
                立即開始
              </button>
            )}
          </>
        )}
      </div>

      {/* Mobile Dropdown Menu */}
      {isMobile && isMenuOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '5%',
          width: '200px',
          background: 'rgba(0, 0, 0, 0.9)',
          backdropFilter: 'blur(20px)',
          borderRadius: '12px',
          border: '1px solid rgba(135, 206, 235, 0.3)',
          padding: '1rem',
          marginTop: '0.5rem',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
          zIndex: 999
        }}>
          {navLinks.map(link => (
            <a
              key={link.path}
              onClick={() => {
                navigate(link.path);
                setIsMenuOpen(false);
              }}
              style={{
                display: 'block',
                color: location.pathname === link.path ? '#87CEEB' : 'rgba(255, 255, 255, 0.8)',
                textDecoration: 'none',
                fontSize: 'var(--font-xs)',
                fontWeight: location.pathname === link.path ? '600' : '400',
                cursor: 'pointer',
                padding: '0.75rem 1rem',
                borderRadius: '8px',
                marginBottom: '0.5rem',
                transition: 'all 0.2s ease',
                background: location.pathname === link.path ? 'rgba(135, 206, 235, 0.1)' : 'transparent'
              }}
              onMouseEnter={(e) => {
                if (location.pathname !== link.path) {
                  e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                  e.target.style.color = '#ffffff';
                }
              }}
              onMouseLeave={(e) => {
                if (location.pathname !== link.path) {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                }
              }}
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => {
              navigate('/register');
              setIsMenuOpen(false);
            }}
            style={{
              width: '100%',
              background: 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)',
              border: 'none',
              color: '#ffffff',
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: 'var(--font-xs)',
              fontWeight: '600',
              boxShadow: '0 4px 12px rgba(135, 206, 235, 0.4)',
              marginTop: '0.5rem',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.02)';
              e.target.style.boxShadow = '0 6px 16px rgba(135, 206, 235, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 4px 12px rgba(135, 206, 235, 0.4)';
            }}
          >
            立即開始
          </button>
        </div>
      )}
    </nav>
  );
}

export default Navigation;
